import { makeStyles, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, } from 'react-redux';
import {setBillInfoToSch} from '../Billing/blMakeData';
import * as comMod from '../../commonModule';
import * as Actions from '../../Actions';

import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { lightBlue, teal } from '@material-ui/core/colors';

const useStyles = makeStyles({
    invoiceOpt: {
        display: 'flex',
        flexDirection: 'column',
        '& .opts': {
            display: 'flex',
            justifyContent: "end",
            justifyContent: 'space-between',
            padding: 8
        },
        '& .comment': {
            marginTop: 4,
            padding: '0 8px',
            '& .commentButtons': {
                textAlign: 'end',
                marginTop: 8
            }
        }
    }
})

export const convStrToZenspace = (str, triger=false) => {
    let result = "";
    if(triger){
        for(let i=0; i<str.length; i++){
            result += "　";
        }
    }else{
        result = str;
    }

    return result;
}


export const InvoiceOpt = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const allstate = useSelector(state=>state);
    const {com, hid, bid, stdDate} = allstate;

    const comEtc = com.etc ?com.etc :{};
    const display_date = comMod.findDeepPath(
      comEtc, 'configReports.invoice.displayDate', 
    )
    const display_notice = comMod.findDeepPath(
      comEtc, 'configReports.invoice.displayNotice', 
    )
    const reports_notice = comMod.findDeepPath(
        comEtc, 'reports.invoice.notice',
    )
  
    const [displayDate, setDisplayDate] = useState(display_date!==undefined ?display_date :true);
    const [displayNotice, setDisolayNotice] = useState(display_notice!==undefined ?display_notice :true);
    const originComment = reports_notice!==undefined ?comMod.brtoLf(reports_notice) :""
    const [comment, setComment] = useState(reports_notice!==undefined ?comMod.brtoLf(reports_notice) :"");
    const [openForm, setOpenForm] = useState(false);

    const DisplayDate = () => {
        const handleChange = (ev) => {
            setDisplayDate(ev.target.checked);
        }
    
        return(
            <FormControlLabel
                control={
                    <Checkbox
                    checked={(displayDate)}
                    onChange={(ev)=>handleChange(ev)}
                    name='displayDate'
                    color="primary"
                    />
                }
                label='日付表示'
            />
        )
    }
    
    const DisplayNotice = () => {
        const handleChange = (ev) => {
            setDisolayNotice(ev.target.checked);
        }
    
        return(
            <FormControlLabel
                control={
                    <Checkbox
                    checked={(displayNotice)}
                    onChange={(ev)=>handleChange(ev)}
                    name='displayNotice'
                    color="primary"
                    />
                }
                label='備考表示'
            />
        )
    }
    
    const DisplayOptButton = () => { 
        const comEtc = com.etc ?com.etc :{};
        if(!comEtc.configReports) comEtc["configReports"] = {};
        if(!comEtc.configReports.invoice) comEtc.configReports["invoice"] = {};
        const handleClick = () => {
            comEtc.configReports.invoice["displayDate"] = displayDate;
            comEtc.configReports.invoice["displayNotice"] = displayNotice;
            const sendPrms = {
                ...com, hid, bid, date: stdDate,
                addiction: com.addiction,
                etc: comEtc,
            };
            dispatch(Actions.sendBrunch(sendPrms));
        }
    
        return(
            <Button
                variant='contained'
                name='帳票オプション書き込み'
                onClick={()=>handleClick()}
            >
                登録
            </Button>
        )
    }

    const clickCommentSendButton = () => {
        if(!comEtc.reports) comEtc.reports = {};
        if(!comEtc.reports.invoice) comEtc.reports.invoice = {};
        comEtc.reports.invoice.notice = comMod.lfToBr(comment);
        const sendPrms = {
            ...com, hid, bid, date: stdDate,
            addiction: com.addiction,
            etc: comEtc,
        };
        dispatch(Actions.sendBrunch(sendPrms));
    }

    return(
        <div className={`${classes.invoiceOpt} reportCntRow`} style={{marginBottom: 32}}>
            <div className='opts'>
                <Button
                    variant="contained"
                    disabled={openForm}
                    style={{opacity: openForm ?0 :1}}
                    color='primary'
                    onClick={() => setOpenForm(!openForm)}
                >
                    コメント追加・編集
                </Button>
                <div>
                    <DisplayDate />
                    <DisplayNotice />
                    <DisplayOptButton />
                </div>
            </div>
            {openForm
                ?<div className='comment'>
                    <TextField
                        id="outlined-multiline-flexible"
                        variant="outlined"
                        label="コメント"
                        multiline
                        maxRows={4}
                        value={comment ?comment :""}
                        style={{width: '100%'}}
                        onChange={e => setComment(e.target.value)}
                    />
                    <div className='commentButtons'>
                        <Button
                            variant='contained'
                            style={{marginRight: 8, backgroundColor: lightBlue[800], color: 'white'}}
                            onClick={() => {setComment(originComment); setOpenForm(false)}}
                        >
                            キャンセル
                        </Button>
                        <Button
                            variant='contained'
                            color="primary"
                            onClick={clickCommentSendButton}
                        >
                            書き込み
                        </Button>
                    </div>
                </div>
                :comment ?<div className='comment'>
                    {/* {originComment} */}
                    <TextField
                        // id="outlined-multiline-flexible"
                        variant="outlined"
                        label="コメント"
                        disabled={!openForm}
                        multiline
                        maxRows={4}
                        value={comment}
                        style={{width: '100%'}}
                        onChange={e => setComment(e.target.value)}
                    />
                </div> :null
            }
        </div>
    )
}